import blue from "../../assets/patterns/blue.png";
import red from "../../assets/patterns/red.png";
import green from "../../assets/patterns/green.png";
import yellow from "../../assets/patterns/yellow.png";
import MemberImage from "../../assets/team/member.png";
import AasthaPatelImage from "../../assets/team/aastha-patel.png";
import AnmoldeepSinghImage from "../../assets/team/anmoldeep-singh.png";
import AtharvaBadkasImage from "../../assets/team/atharva-badkas.png";
import ChirayuSakarkarImage from "../../assets/team/chirayu-sakarkar.png";
import HenayLakhwaniImage from "../../assets/team/henay-lakhwani.png";
import JayaSinghImage from "../../assets/team/jaya-singh.png";
import NeedhiDeshmukhImage from "../../assets/team/needhi-deshmukh.png";
import NikhilAparajitImage from "../../assets/team/nikhil-aparajit.png";
import ParasPatleImage from "../../assets/team/paras-patle.png";
import ParthKawareImage from "../../assets/team/parth-kaware.png";
// import PrachiYerojwarImage from "../../assets/team/prachi-yerojwar.png";
import PrathameshDukareImage from "../../assets/team/prathamesh-dukare.png";
import PratikAgrawalImage from "../../assets/team/pratik-agrawal.png";
import RamyaKappagantuImage from "../../assets/team/ramya-kappagantu.png";
// import RohitDaftariImage from "../../assets/team/rohit-daftari.png";
import SahilDafadeImage from "../../assets/team/sahil-dafade.png";
import SalmanShaikhImage from "../../assets/team/salman-shaikh.png";
import SaniyaImrozeImage from "../../assets/team/saniya-imroze.png";
import SanskarMangeImage from "../../assets/team/sanskar-mange.png";
import ShreyashChoudharyImage from "../../assets/team/shreyash-choudhary.png";
import ShubhamJeswaniImage from "../../assets/team/shubham-jeswani.png";
// import SuyashDahake from "../../assets/team/suyash-dahake.png";
// import TanmayRaoImage from "../../assets/team/tanmay-rao.png";
import TejaswiniPadoleImage from "../../assets/team/tejaswini-padole.png";
import GauravImage from "../../assets/team/gaurav.jpg";
import TusharImage from "../../assets/team/tushar.jpg";
import BhaveshChaudhariImage from "../../assets/team/bhavesh-chaudhari.png";
import RaghavImage from "../../assets/team/raghav.png";
import SohailImage from "../../assets/team/sohail.jpeg";
import SaishImage from "../../assets/team/saish.jpeg";
import AkanshaImage from "../../assets/team/akansha.jpg";
import ShantanuImage from "../../assets/team/shantanu.jpeg";
import MurliImage from "../../assets/team/murli_2.jpeg";
import NirajImage from "../../assets/team/niraj.jpeg";
import AmanImage from "../../assets/team/aman-thakur.png";
import VaishnaviKamekar from "../../assets/team/vaishnavi-kamekar.jpg"; 
import VedantiKhode from "../../assets/team/vedanti-khode.png";

const teamData = [
  {
    id: 1,
    imgSrc: ShantanuImage,
    name: "Shantanu V.",
    designation: "designation",
    twitterLink: "https://twitter.com/thecoderpanda",
    linkedinLink: "https://www.linkedin.com/in/thecoderpanda/",
    patternSrc: red,
  },
  {
    id: 2,
    imgSrc: NirajImage,
    name: "Niraj Choudhary",
    designation: "designation",
    twitterLink: "https://twitter.com/choudhari_niraj",
    linkedinLink: "https://www.linkedin.com/in/niraj-choudhari",
    patternSrc: blue,
  },
  {
    id: 3,
    imgSrc: MurliImage,
    name: "Mrunalsingh Zire",
    designation: "designation",
    twitterLink: "https://twitter.com/MSzire",
    linkedinLink: "https://www.linkedin.com/in/mszire/",
    patternSrc: green,
  },
  {
    id: 4,
    imgSrc: TusharImage,
    name: "Tushar Joshi",
    designation: "designation",
    twitterLink:
      "https://twitter.com/joshijikaladkaa?t=xc6Uo-qTZgvbf9OoUj2gfg&s=08",
    linkedinLink: "https://www.linkedin.com/in/tushar2179/",
    patternSrc: yellow,
  },
  {
    id: 5,
    imgSrc: SohailImage,
    name: "Sohail Pathan",
    designation: "designation",
    twitterLink: "https://twitter.com/iamspathan",
    linkedinLink: "https://www.linkedin.com/in/iamspathan/",
    patternSrc: blue,
  },
  {
    id: 6,
    imgSrc: AnmoldeepSinghImage,
    name: "Anmoldeep Singh",
    designation: "designation",
    twitterLink: "https://mobile.twitter.com/Anmoldeep1509",
    linkedinLink: "https://www.linkedin.com/mwlite/in/csesingh",
    patternSrc: blue,
  },
  {
    id: 20,
    imgSrc: RaghavImage,
    name: "Raghav Agrawal",
    designation: "designation",
    twitterLink: "https://twitter.com/Araghav_",
    linkedinLink: "https://www.linkedin.com/in/raghav1701/",
    patternSrc: green,
  },
    {
    id: 7,
    imgSrc: AkanshaImage,
    name: "Akanksha Nitnaware",
    designation: "designation",
    twitterLink: "",
    linkedinLink: "",
    patternSrc: yellow,
  },
  {
    id: 8,
    imgSrc: HenayLakhwaniImage,
    name: "Henay Lakhwani",
    designation: "designation",
    twitterLink: "https://twitter.com/LakhwaniHenay",
    linkedinLink: "https://www.linkedin.com/in/henaylakhwani/",
    patternSrc: green,
  },
  {
    id: 9,
    imgSrc: GauravImage,
    name: "Gaurav Deshmukh",
    designation: "designation",
    twitterLink:
      "https://twitter.com/GauravD69463092?t=EBNEN-QDmOTlEfPmfBCgCg&s=09",
    linkedinLink: "https://www.linkedin.com/in/gaurav-deshmukh-13296118b",
    patternSrc: green,
  },
  {
    id: 10,
    imgSrc: NikhilAparajitImage,
    name: "Nikhil Aparajit",
    designation: "designation",
    twitterLink: "https://twitter.com/nikhil_aparajit",
    linkedinLink: "https://www.linkedin.com/in/nikhil-aparajit/",
    patternSrc: red,
  },
  {
    id: 11,
    imgSrc: SaishImage,
    name: "Saish Adlak",
    designation: "designation",
    twitterLink: "https://twitter.com/saish_adk?t=B8IXLwtlNRV7vdqbwhvDig&s=09",
    linkedinLink: "https://www.linkedin.com/in/saishadlak/",
    patternSrc: yellow,
  },
  {
    id: 12,
    imgSrc: RamyaKappagantuImage,
    name: "Ramya Kappagantu",
    designation: "designation",
    twitterLink: "https://twitter.com/ramyaK122",
    linkedinLink: "https://www.linkedin.com/in/ramya-kappagantu-a588a6162",
    patternSrc: yellow,
  },

  {
    id: 13,
    imgSrc: BhaveshChaudhariImage,
    name: "Bhavesh Chaudhari",
    designation: "designation",
    twitterLink: "https://twitter.com/bhaveshc0",
    linkedinLink: "https://www.linkedin.com/in/bhavesh-chaudhari-bb4966208/",
    patternSrc: blue,
  },
  {
    id: 14,
    imgSrc: PrathameshDukareImage,
    name: "Prathamesh Dukare",
    designation: "designation",
    twitterLink: "https://twitter.com/prathameshtwits",
    linkedinLink: "https://LinkedIn.com/in/prathameshdukare",
    patternSrc: red,
  },
  {
    id: 15,
    imgSrc: ParasPatleImage,
    name: "Paras Patle",
    designation: "designation",
    twitterLink: "https://twitter.com/ParasPatle4",
    linkedinLink: "https://www.linkedin.com/in/paras-patle-0407051a1",
    patternSrc: yellow,
  },
//   {
//     id: 7,
//     imgSrc: AkanshaImage,
//     name: "Akanksha Nitnaware",
//     designation: "designation",
//     twitterLink: "",
//     linkedinLink: "",
//     patternSrc: yellow,
//   },
  {
    id: 34,
    imgSrc: AmanImage,
    name: "Aman Thakur",
    designation: "designation",
    twitterLink: "https://twitter.com/unrealaman",
    linkedinLink: "https://www.linkedin.com/in/obliviousgrain",
    patternSrc: blue,
  },
  {
    id: 40,
    imgSrc: VaishnaviKamekar,
    name: "Vaishnavi Kamekar",
    designation: "designation",
    twitterLink: "https://twitter.com/VKamekar31",
    linkedinLink: "https://www.linkedin.com/in/vaishnavikamekar31",
    patternSrc: red,
  },
  {
    id: 41,
    imgSrc: VedantiKhode,
    name: "Vedanti Khode",
    designation: "designation",
    twitterLink:
      "https://twitter.com/KhodeVedanti",
    linkedinLink: "https://www.linkedin.com/in/vedantikhode",
    patternSrc: yellow,
  },
  {
    id: 16,
    imgSrc: ShubhamJeswaniImage,
    name: "Shubham Jeswani",
    designation: "designation",
    twitterLink: "https://twitter.com/JeswaniShubham",
    linkedinLink: "https://www.linkedin.com/in/shubham-jeswani-5615b51a3/",
    patternSrc: green,
  },
  {
    id: 17,
    imgSrc: NeedhiDeshmukhImage,
    name: "Needhi Deshmukh",
    designation: "designation",
    twitterLink: "",
    linkedinLink: "https://www.linkedin.com/in/needhi-deshmukh-6089b2192",
    patternSrc: blue,
  },
  {
    id: 18,
    imgSrc: SalmanShaikhImage,
    name: "Salman Shaikh",
    designation: "designation",
    twitterLink: "https://twitter.com/Salman_8778",
    linkedinLink: "https://www.linkedin.com/in/devsalmanshaikh/",
    patternSrc: blue,
  },

  {
    id: 19,
    imgSrc: ChirayuSakarkarImage,
    name: "Chirayu Sakarkar",
    designation: "designation",
    twitterLink: "https://twitter.com/theopdesigner",
    linkedinLink: "https://www.linkedin.com/in/chirayusakarkar/",
    patternSrc: red,
  },
  {
    id: 21,
    imgSrc: TejaswiniPadoleImage,
    name: "Tejaswini Padole",
    designation: "designation",
    twitterLink: "",
    linkedinLink: "https://www.linkedin.com/in/tejaswini-padole-ba254b223",
    patternSrc: green,
  },
  {
    id: 22,
    imgSrc: AasthaPatelImage,
    name: "Aastha Patel",
    designation: "designation",
    twitterLink: "https://twitter.com/Aasthapatel_20",
    linkedinLink: "https://www.linkedin.com/in/aastha-patel-307b1a19b/",
    patternSrc: blue,
  },
  {
    id: 23,
    imgSrc: AtharvaBadkasImage,
    name: "Atharva Badkas",
    designation: "designation",
    twitterLink: "https://twitter.com/zone_1007",
    linkedinLink: "https://www.linkedin.com/in/atharvabadkas",
    patternSrc: red,
  },
  {
    id: 24,
    imgSrc: JayaSinghImage,
    name: "Jaya Singh",
    designation: "designation",
    twitterLink: "https://twitter.com/jayasingh_14",
    linkedinLink: "https://www.linkedin.com/in/jaya-singh-056387227",
    patternSrc: yellow,
  },
  {
    id: 25,
    imgSrc: ParthKawareImage,
    name: "Parth Kaware",
    designation: "designation",
    twitterLink: "twitter.com/gimmepizzzaaaa",
    linkedinLink: "https://www.linkedin.com/in/parth-kaware",
    patternSrc: green,
  },
  {
    id: 26,
    imgSrc: PratikAgrawalImage,
    name: "Pratik Agrawal",
    designation: "designation",
    twitterLink: "https://twitter.com/Rudra_Pratik",
    linkedinLink: "https://www.linkedin.com/in/rudrapratik",
    patternSrc: blue,
  },
  {
    id: 27,
    imgSrc: SahilDafadeImage,
    name: "Sahil Dafade",
    designation: "designation",
    twitterLink: "https://www.linkedin.com/in/sahil-dafade-39b8b821b",
    linkedinLink: "https://twitter.com/DafadeSahil",
    patternSrc: red,
  },
  {
    id: 28,
    imgSrc: ShreyashChoudharyImage,
    name: "Shreyash Choudhary",
    designation: "designation",
    twitterLink: "https://twitter.com/Shreyash1488",
    linkedinLink: "https://www.linkedin.com/in/shreyash14/",
    patternSrc: yellow,
  },
  {
    id: 32,
    imgSrc: SaniyaImrozeImage,
    name: "Saniya Imroze",
    designation: "designation",
    twitterLink: "https://twitter.com/ImrozeSaniya",
    linkedinLink: "https://www.linkedin.com/in/saniya-imroze-144a72192",
    patternSrc: green,
  },
  {
    id: 33,
    imgSrc: SanskarMangeImage,
    name: "Sanskar Mange",
    designation: "designation",
    twitterLink: "https://twitter.com/sanskaaarM",
    linkedinLink: "https://www.linkedin.com/in/sanskar-mange-9001b0233",
    patternSrc: blue,
  },
];

export default teamData;
